import { call, put, takeLatest, select } from "redux-saga/effects";
import * as types from "./reportActionTypes";
import * as actions from "./reportActions";
import reportsApi from "../api/ServiceApi";

export const getOidc = state => state.oidc;

function* loadReports() {
  try {
    let oidc = yield select(getOidc);

    const result = yield call(reportsApi.getReports, oidc.user);
    yield put(actions.loadReportsSuccess(result));
  } catch (e) {
    yield put(actions.loadReportsFailed(e.message));
  }
}

export function* loadReportsSaga() {
  yield takeLatest(types.LOAD_REPORTS, loadReports);
}

function* downloadReport(action) {
  try {
    let oidc = yield select(getOidc);

    const result = yield call(
      reportsApi.downloadReport,
      oidc.user,
      action.payload.reportId
    );
    const newBlob = new Blob([result], { type: "application/pdf" });
    const filename = `${action.payload.filename}.pdf`;

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob, filename);
      return;
    }

    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement("a");
    document.body.appendChild(link);
    link.href = data;
    link.download = filename;
    link.click();
    setTimeout(function() {
      window.URL.revokeObjectURL(data);
    }, 100);
  } catch (e) {
    yield put(actions.downloadReportFailed(e.message));
  }
}

export function* downloadReportSaga(accessToken) {
  yield takeLatest(types.DOWNLOAD_REPORT, downloadReport);
}



// WEBPACK FOOTER //
// ./src/reports/sagas.js